import React, { useEffect, useState } from "react";
import { ADMIN_NAV_EVENT, type AdminNavDetail } from "@/lib/adminNav";

import AdminECardCardsPage from "./AdminECardCardsPage";
import AdminECardPromosPage from "./AdminECardPromosPage";
import AdminECardDrawsPage from "./AdminECardDrawsPage";
import AdminECardReportingPage from "./AdminECardReportingPage";
import AdminECardTagsPage from "./AdminECardTagsPage";
import ECardCRMMatchWizard from "@/components/ECardCRMMatchWizard";

type Tab = "cards" | "automatch" | "promos" | "tags" | "draws" | "reporting";

const ecardTabs: { key: Tab; label: string }[] = [
  { key: "cards", label: "Cards" },
  { key: "automatch", label: "Auto-Match" },
  { key: "promos", label: "Promotions" },
  { key: "tags", label: "Tags" },
  { key: "draws", label: "Draws" },
  { key: "reporting", label: "Reporting" },
];

export default function AdminECardHub() {
  const [tab, setTab] = useState<Tab>("cards");

  useEffect(() => {
    const onNav = (e: Event) => {
      const detail = (e as CustomEvent<AdminNavDetail>).detail;
      if (detail?.tab !== "ecard") return;
      if (detail.search) setTab("cards");
      // Deep-link from the Site Map (Settings -> Site Map) -- see
      // adminNav.ts. Nested tags/reporting sub-tab (path[1]) is consumed by
      // AdminECardTagsPage.tsx / AdminECardReportingPage.tsx themselves.
      if (detail.path?.[0]) setTab(detail.path[0] as Tab);
    };

    window.addEventListener(ADMIN_NAV_EVENT, onNav);
    return () => window.removeEventListener(ADMIN_NAV_EVENT, onNav);
  }, []);

  return (
    <div className="space-y-6 p-4">
      <div>
        <h1 className="text-2xl font-bold golden-text">Admin • eCard</h1>
        <p className="text-sm text-muted-foreground mt-1">
          Manage cards, promotions, tags, draws, reporting and CRM matching.
        </p>
      </div>

      <div className="flex gap-1 border-b border-gray-700 pb-0 flex-wrap">
        {ecardTabs.map((item) => (
          <button
            key={item.key}
            type="button"
            onClick={() => setTab(item.key)}
            className={`px-4 py-2.5 text-sm font-medium rounded-t-lg transition-colors border border-b-0 ${
              tab === item.key
                ? "bg-gray-800 text-yellow-500 border-gray-700"
                : "bg-transparent text-gray-400 border-transparent hover:text-gray-200 hover:bg-gray-800/50"
            }`}
          >
            {item.label}
          </button>
        ))}
      </div>

      <div>
        {tab === "cards" && <AdminECardCardsPage />}
        {tab === "automatch" && <ECardCRMMatchWizard />}
        {tab === "promos" && <AdminECardPromosPage />}
        {tab === "tags" && <AdminECardTagsPage />}
        {tab === "draws" && <AdminECardDrawsPage />}
        {tab === "reporting" && <AdminECardReportingPage />}
      </div>
    </div>
  );
}